import script from "./contract-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./contract-list.vue?vue&type=script&lang=ts&setup=true"

import "./contract-list.vue?vue&type=style&index=0&id=6d7561bc&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d7561bc"]])

export default __exports__